import { MessageBarType, IMessageBarStyles } from '@fluentui/react';
import { ITheme, FontSizes } from '@fluentui/theme';

export interface IOneButtonMessageBarStyleProps {
  theme: ITheme;
  messageBarType: MessageBarType;
  isTeams: boolean;
}

export const getOneButtonMessageBarStyles = (props: IOneButtonMessageBarStyleProps): IMessageBarStyles => {
  let isTeams = props.isTeams;
  let color: string;
  switch (props.messageBarType) {
    case MessageBarType.info:
      color = props.theme.isInverted ? '#60CDFF' : '#005FB7';
      break;
    case MessageBarType.warning:
      color = props.theme.isInverted ? '#FCE100' : '#9D5D00';
      break;
    case MessageBarType.severeWarning:
    case MessageBarType.blocked:
    case MessageBarType.error:
      color = props.theme.isInverted ? '#FF99A4' : '#C42B1C';
      break;
    case MessageBarType.success:
      color = props.theme.isInverted ? '#6CCB5F' : '#0F7B0F';
      break;
    default:
      break;
  }
  return {
    root: {
      borderRadius: isTeams ? '2px' : '4px',
      ...(isTeams && {
        background: props.theme.semanticColors.inputBackground,
        color: props.theme.semanticColors.inputText,
        boxSizing: 'border-box',
        boxShadow: '0 2px 4px rgb(0 0 0 / 10%)',
        marginBottom: '20px',
        border: `1px solid ${props.theme.semanticColors.inputBorder}`,
      }),
    },
    iconContainer: {
      margin: '16px 0px 8px 12px',
    },
    icon: {
      color: color,
      fontSize: '17px',
    },
    actions: {
      flexDirection: 'row',
      margin: '12px 12px 16px 40px',
    },
    dismissal: {
      margin: '5px',
      selectors: {
        i: {
          fontSize: '12px !important',
          ...(isTeams && { color: `${props.theme.semanticColors.inputText} !important` }),
        },
      },
    },
    text: {
      margin: '13px 8px 8px 12px',
      fontSize: FontSizes.medium,
      selectors: {
        a: {
          textDecoration: 'none',
          color: props.theme.palette.accent,
        },
      },
    },
    innerText: {
      lineHeight: '20px',
    },
  };
};
